<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="contract-number">Номер договора</label>
    <input
      type="text"
      class="form-control"
      id="contract-number"
      placeholder="Введите номер договора"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'contract-number-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ContractNumber.vue?a949d0c8